var _path, _path2, _path3, _path4, _g, _rect, _rect2, _mask, _mask2, _g2, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgSoonPurpleBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 710,
    height: 391,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EDE7F6",
    d: "m161.088 154.333 23.319-13.462 23.174 13.378-23.32 13.462z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B39DDB",
    d: "m162.809 155.327 21.588-12.463 21.453 12.385-21.588 12.463z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDE7F6",
    d: "m536.744 181.299 23.319-13.462 23.174 13.378-23.32 13.462z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#B39DDB",
    d: "m538.465 182.292 21.588-12.463 21.453 12.385-21.588 12.463z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M67.724 137.573v-2.9h-3.715v6.151l.009.005c.019.648.456 1.292 1.313 1.786l38.31 22.118c1.752 1.011 4.591 1.011 6.342 0l94.061-54.302c.835-.482 1.272-1.107 1.311-1.738V108.68a1.37 1.37 0 0 0 0-.157l.007-6.188-5.297 2.137-34.332-19.82c-1.751-1.01-4.591-1.01-6.342 0l-91.667 52.921"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 115.933,
    height: 51.56,
    fill: "#673AB7",
    rx: 5,
    transform: "scale(1.22477 .70707)rotate(-45 255.307 33.978)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 115.933,
    height: 51.56,
    fill: "url(#c)",
    fillOpacity: 0.3,
    rx: 5,
    transform: "scale(1.22477 .70707)rotate(-45 255.307 33.978)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "d",
    width: 141,
    height: 81,
    x: 64,
    y: 78,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115.933,
    height: 51.56,
    fill: "#673AB7",
    rx: 5,
    transform: "scale(1.22477 .70707)rotate(-45 255.307 33.978)"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "e",
    width: 141,
    height: 81,
    x: 64,
    y: 78,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115.933,
    height: 51.56,
    fill: "#673AB7",
    rx: 5,
    transform: "scale(1.22477 .70707)rotate(-45 255.307 33.978)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.373,
    height: 64.373,
    fill: "#5E35B1",
    rx: 5,
    transform: "scale(1.22477 .70707)rotate(-45 184.747 -51.995)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 63.373,
    height: 63.373,
    x: 0.866,
    stroke: "#5E35B1",
    opacity: 0.7,
    rx: 4.5,
    transform: "scale(1.22477 .70707)rotate(-45 182.27 -15.934)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 200.346,
    x2: 71.029,
    y1: 102.359,
    y2: 158.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A491C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7C5F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 8.153,
    x2: 57.196,
    y1: -0.146,
    y2: 72.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 269.353,
    height: 229.597,
    x: 0.009,
    y: 83.894,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 84
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 32
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.403922 0 0 0 0 0.227451 0 0 0 0 0.717647 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSoonPurpleBlock);
export default __webpack_public_path__ + "static/media/img-soon-purple-block.aee0d968e2acdec60881ad1ff62d5ff3.svg";
export { ForwardRef as ReactComponent };